import { Menu } from "@/types/menu";

const menuData: Menu[] = [
  {
    id: 1,
    title: "Inicio",
    path: "/",
    newTab: false,
    
  },
  {
    id: 2,
    title: "Nosotros",
    // path: "/nosotros",
    newTab: false,
    submenu: [
      {
        id: 21,
        title: "Acerca de Udaxen",
        path: "/nosotros/acerca-de-udaxen",
        newTab: false,
      },
      {
        id: 22,
        title: "Nuestro ADN",
        path: "/nosotros/nuestro-adn",
        newTab: false,
      },
      {
        id: 23,
        title: "Mentores Udaxen",
        path: "/nosotros/mentores",
        newTab: false,
      },
    ]
  },
  {
    id: 3,
    title: "Carreras",
    //path: "/networker-pro",
    newTab: false,
    submenu: [
      {
        id: 31,
        title: "Network Marketing",
        path: "/carreras/networker-pro",
        newTab: false,
      },
      // {
      //   id: 32,
      //   title: "Networker Pro",
      //   path: "/carreras/networker-pro",
      //   newTab: false,
      // },
    ]
  },
  {
    id: 4,
    title: "Educación Continua",
    // path: "/cursos-udaxen",
    newTab: false,
    submenu: [
      {
        id: 41,
        title: "Cursos",
        path: "/cursos-udaxen",
        newTab: false,
      },
      {
        id: 42,
        title: "Curación",
        path: "/educacion-continua/curacion",
        newTab: false,
      },
      {
        id: 43,
        title: "Biodescodificación",
        path: "/educacion-continua/biodescodificacion",
        newTab: false,
      },
      {
        id: 44,
        title: "Sunya",
        path: "/educacion-continua/sunya",
        newTab: false,
      },
      {
        id: 45,
        title: "Liderazgo",
        path: "/educacion-continua/liderazgo",
        newTab: false,
      },
      {
        id: 46,
        title: "Biblioteca",
        path: "/biblioteca",
        newTab: false,
      },
      {
        id: 47,
        title: "En Vivo",
        path: "/live",
        newTab: false,
      }
      // },
      // {
      //   id: 42,
      //   title: "",
      //   path: "/cursos-udaxen",
      //   newTab: false,
      // },
    ]
  },
  {
    id: 5,
    title: "Logros",
    // path: "/cursos-udaxen",
    newTab: false,
    submenu: [
      {
        id: 51,
        title: "Testimonios",
        path: "/logros/testimonios",
        newTab: false,
      },
      // {
      //   id: 52,
      //   title: "Viajes",
      //   path: "/testimonios",
      //   newTab: false,
      // },
      {
        id: 53,
        title: "Éxitos",
        path: "/logros/exitos",
        newTab: false,
      },
      {
        id: 54,
        title: "Graduaciones",
        path: "/logros/graduaciones",
        newTab: false,
      },
      {
        id: 55,
        title: "Rangos",
        path: "/logros/rangos",
        newTab: false,
      },
      // {
      //   id: 56,
      //   title: "Niel Arroe",
      //   path: "/testimonios",
      //   newTab: false,
      // },
      // {
      //   id: 57,
      //   title: "Embajadores",
      //   path: "/testimonios",
      //   newTab: false,
      // },
      // {
      //   id: 58,
      //   title: "Nuevos Rangos",
      //   path: "/testimonios",
      //   newTab: false,
      // }
      // },
      // {
      //   id: 42,
      //   title: "",
      //   path: "/cursos-udaxen",
      //   newTab: false,
      // },
    ]
  },
  {
    id: 6,
    title: "Eventos",
    // path: "/cursos-udaxen",
    newTab: false,
    submenu: [
      {
        id: 61,
        title: "Seminarios",
        path: "/eventos/seminarios",
        newTab: false,
      },
      {
        id: 62,
        title: "Talleres",
        path: "/eventos/talleres",
        newTab: false,
      },
      {
        id: 63,
        title: "Convenciones",
        path: "/eventos/convenciones",
        newTab: false,
      },
      {
        id: 64,
        title: "Aniversarios",
        path: "/eventos/aniversarios",
        newTab: false,
      },
      {
        id: 65,
        title: "Actividades",
        path: "/eventos/actividades",
        newTab: false,
      },
      {
        id: 66,
        title: "Eventos",
        path: "/eventos/eventos",
        newTab: false,
      },
    ]
  },
  // {
  //   id: 7,
  //   title: "contacto",
  //   path: "/contacto",
  //   newTab: false,
  // }
  
];
export default menuData;

